/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/countries';
import '../common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "au": {
                "nested": {
                  "common": {
                    "nested": {
                      "Company": {
                        "fields": {
                          "legalBusinessName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "australianBusinessNumber": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "businessStructure": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "companyAddress": {
                            "type": ".squareup.onboard.activation.au.common.Address",
                            "id": 4,
                            "rule": "optional"
                          },
                          "australianCompanyNumber": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "Address": {
                        "fields": {
                          "addressLine1": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "addressLine2": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "city": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "state": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "postalCode": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "countryCode": {
                            "type": ".squareup.common.countries.Country",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": "AU"
                            }
                          }
                        }
                      },
                      "CompanyRelationship": {
                        "values": {
                          "SOLE_TRADER": 1,
                          "OFFICER_OR_AGENT": 2,
                          "DIRECTOR": 3,
                          "COMPANY_SECRETARY": 4,
                          "SOLE_DIRECTOR": 5,
                          "COMPANY_DIRECTORS": 6,
                          "PARTNERS": 7,
                          "BENEFICIAL_OWNERS": 8,
                          "PRESIDENT": 9,
                          "SECRETARY": 10,
                          "TREASURER": 11,
                          "ACCOUNT_HOLDER": 12,
                          "MEMBER": 13,
                          "TRUSTEE": 14,
                          "SETTLOR": 15,
                          "APPOINTOR": 16,
                          "OTHER": 17
                        }
                      },
                      "Persona": {
                        "fields": {
                          "firstName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lastName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "phoneNumber": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "birthDate": {
                            "type": ".squareup.onboard.activation.common.BirthDate",
                            "id": 4,
                            "rule": "optional"
                          },
                          "companyRelationship": {
                            "type": ".squareup.onboard.activation.au.common.CompanyRelationship",
                            "id": 5,
                            "rule": "optional"
                          },
                          "incorrect": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          },
                          "incorrectReason": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "middleName": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          }
                        }
                      },
                      "DocumentType": {
                        "values": {
                          "NONE": 0,
                          "DRIVERS_LICENSE": 1,
                          "PASSPORT": 2,
                          "MEDICARE": 3
                        }
                      },
                      "DriversLicense": {
                        "fields": {
                          "stateCode": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "number": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cardNumber": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "Passport": {
                        "fields": {
                          "countryCode": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "number": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "gender": {
                            "type": ".squareup.onboard.activation.common.Gender",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "Medicare": {
                        "fields": {
                          "cardNumber": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "referenceNumber": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "middleNameOnCard": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "expirationDateYear": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "expirationDateMonth": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional"
                          },
                          "expirationDateDay": {
                            "type": "int32",
                            "id": 6,
                            "rule": "optional"
                          },
                          "cardColor": {
                            "type": ".squareup.onboard.activation.au.common.MedicareCardColor",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "MedicareCardColor": {
                        "values": {
                          "G": 1,
                          "B": 2,
                          "Y": 3
                        }
                      },
                      "Document": {
                        "fields": {
                          "documentType": {
                            "type": ".squareup.onboard.activation.au.common.DocumentType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "driversLicense": {
                            "type": ".squareup.onboard.activation.au.common.DriversLicense",
                            "id": 2,
                            "rule": "optional"
                          },
                          "passport": {
                            "type": ".squareup.onboard.activation.au.common.Passport",
                            "id": 3,
                            "rule": "optional"
                          },
                          "medicare": {
                            "type": ".squareup.onboard.activation.au.common.Medicare",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.Company && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.Address && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.CompanyRelationship && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.Persona && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.DocumentType && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.DriversLicense && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.Passport && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.Medicare && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.MedicareCardColor && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.au?.nested?.common?.nested?.Document) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Company @ squareup/onboard/activation/au/common.proto at 13:1
 */
export const Company = $root.lookupType('squareup.onboard.activation.au.common.Company');
fixType(Company);
Builder.createAndAttachToType(Company);
/**
 * SOURCE Address @ squareup/onboard/activation/au/common.proto at 53:1
 */
export const Address = $root.lookupType('squareup.onboard.activation.au.common.Address');
fixType(Address, {
  addressLine1: {
    required: true
  },
  city: {
    required: true
  },
  state: {
    required: true
  },
  postalCode: {
    required: true
  }
});
Builder.createAndAttachToType(Address);
/**
 * SOURCE CompanyRelationship @ squareup/onboard/activation/au/common.proto at 62:1
 */
export const CompanyRelationship = $root.lookupEnum('squareup.onboard.activation.au.common.CompanyRelationship').values;
/**
 * SOURCE Persona @ squareup/onboard/activation/au/common.proto at 92:1
 */
export const Persona = $root.lookupType('squareup.onboard.activation.au.common.Persona');
fixType(Persona, {
  firstName: {
    required: true
  },
  lastName: {
    required: true
  }
});
Builder.createAndAttachToType(Persona);
/**
 * SOURCE DocumentType @ squareup/onboard/activation/au/common.proto at 129:1
 */
export const DocumentType = $root.lookupEnum('squareup.onboard.activation.au.common.DocumentType').values;
/**
 * SOURCE DriversLicense @ squareup/onboard/activation/au/common.proto at 136:1
 */
export const DriversLicense = $root.lookupType('squareup.onboard.activation.au.common.DriversLicense');
fixType(DriversLicense);
Builder.createAndAttachToType(DriversLicense);
/**
 * SOURCE Passport @ squareup/onboard/activation/au/common.proto at 143:1
 */
export const Passport = $root.lookupType('squareup.onboard.activation.au.common.Passport');
fixType(Passport);
Builder.createAndAttachToType(Passport);
/**
 * SOURCE Medicare @ squareup/onboard/activation/au/common.proto at 150:1
 */
export const Medicare = $root.lookupType('squareup.onboard.activation.au.common.Medicare');
fixType(Medicare);
Builder.createAndAttachToType(Medicare);
/**
 * SOURCE MedicareCardColor @ squareup/onboard/activation/au/common.proto at 165:1
 */
export const MedicareCardColor = $root.lookupEnum('squareup.onboard.activation.au.common.MedicareCardColor').values;
/**
 * SOURCE Document @ squareup/onboard/activation/au/common.proto at 179:1
 */
export const Document = $root.lookupType('squareup.onboard.activation.au.common.Document');
fixType(Document);
Builder.createAndAttachToType(Document);